import { css } from '@emotion/react';

import { theme } from '../../theme';

export const buttonOverride = css`
  text-decoration: underline;
  color: var(--color-link);
  background: none;
  border: none;
  padding: 0;
  font: var(--font-p);
  text-transform: none;
  min-height: 0;
  min-width: 0;
  font-size: 14px;
`;
export const buttonContainer = css`
  display: flex;
  justify-content: flex-end;
  margin-top: ${theme.spacing.lg};
  gap: ${theme.spacing.md};
`;
